import type { ApiErrorCode } from '@/api/types'

const PLAN_DIALOG_ERROR_CODES = new Set<ApiErrorCode>([
  'PLAN_PROJECT_LIMIT_REACHED',
  'PLAN_MEMBER_LIMIT_REACHED',
  'PLAN_MEMBER_NOT_ALLOWED',
  'PLAN_FEATURE_NOT_ALLOWED',
  'PLAN_DOWNGRADE_NOT_ALLOWED',
  'PLAN_EXPORT_IMPORT_NOT_ALLOWED',
  'NO_ACTIVE_SUBSCRIPTION',
  'PROJECT_TRANSFER_PLAN_LIMIT',
])

export function shouldOpenPlanDialogForError(code: ApiErrorCode) {
  return PLAN_DIALOG_ERROR_CODES.has(code)
}
